import { render, staticRenderFns } from "./AssuntoAgroVisita.vue?vue&type=template&id=0802a688"
import script from "./AssuntoAgroVisita.vue?vue&type=script&lang=js"
export * from "./AssuntoAgroVisita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports